<!--<ng-container *ngFor="let iconDefinition of icons ">-->
<!--  {{iconDefinition.}}-->
<!--</ng-container>-->

<kendo-dropdownlist
   #dropdownlist
   [data]="icons"
   [textField]="'iconName'"
   [virtual]="true"
   [filterable]="true"
   [style.width]="'100%'"
   [valueField]="'icon'"
>
   <ng-template kendoDropDownListValueTemplate let-dataItem>
      <fa-icon class="sam-margin-right" *ngIf="dataItem" [icon]="dataItem"></fa-icon>
      {{ dataItem?.iconName }}
   </ng-template>

   <ng-template kendoDropDownListItemTemplate let-dataItem>
      <fa-icon class="sam-margin-right" [icon]="dataItem"></fa-icon>
      {{ dataItem.iconName }}
   </ng-template>
</kendo-dropdownlist>
